import axios from 'axios'
import TokenService from './tokenService'

const BASE_URL = 'https://app.yanibasimdakaratay.com/api'

const LibraryService = {
    // Tüm seansların durumunu Getir (GET)
    getAllSeats: async () => {
        try {
            const token = TokenService.getToken()
            const res = await axios.get(`${BASE_URL}/genclik-merkezi-kutuphane-durum`, {
                headers: {
                    Authorization: token,
                },
            })
            return res.data
        } catch (error) {
            console.error('Kütüphane verisi alınamadı:', error)
            return null
        }
    },

    // Rezervasyon Yap (POST)
    reserveSeat: async (reservationData) => {
        try {
            const token = TokenService.getToken()
            const res = await axios.post(`${BASE_URL}/genclik-merkezi-kutuphane-rezervasyon`, reservationData, {
                headers: {
                    Authorization: token,
                },
            })
            return res.data // Beklenen: { success: true, message: '...' }
        } catch (error) {
            console.error('Rezervasyon hatası:', error)
            // Hata mesajını API response'dan al, yoksa genel hata döndür
            if (error.response && error.response.data && error.response.data.message) {
                return { success: false, message: error.response.data.message }
            }
            return { success: false, message: 'Rezervasyon işlemi sırasında bir hata oluştu.' }
        }
    },

    // Kullanıcının Rezervasyonlarını Getir (GET)
    getUserReservations: async () => {
        try {
            const token = TokenService.getToken()
            const res = await axios.get(`${BASE_URL}/genclik-merkezi-kutuphane-rezervasyonlarim?kutuphane_id=1`, {
                headers: {
                    Authorization: token,
                },
            })
            if (res.data && res.data.success) {
                return res.data.items || []
            }
            return []
        } catch (error) {
            console.error('Rezervasyonlarım alınamadı:', error)
            return []
        }
    },

    // Rezervasyon İptal Et (POST)
    cancelReservation: async (reservationId) => {
        try {
            const token = TokenService.getToken()
            const res = await axios.post(`${BASE_URL}/genclik-merkezi-kutuphane-rezervasyon-iptal`, {
                id: reservationId
            }, {
                headers: {
                    Authorization: token,
                },
            })
            return res.data
        } catch (error) {
            console.error('İptal hatası:', error)
            if (error.response && error.response.data && error.response.data.message) {
                return { success: false, message: error.response.data.message }
            }
            return { success: false, message: 'İptal işlemi sırasında bir hata oluştu.' }
        }
    },

    // QR Kod İşlemi (POST)
    processQr: async (qrData, id, randevuIslem) => {
        try {
            const token = TokenService.getToken()
            const qrCodeType = randevuIslem === 'onayla' ? 'check' : 'finished'

            const res = await axios.post(`${BASE_URL}/genclik-merkezi-kutuphane-qr-islem`, {
                id: id,
                qrcode: qrData,
                qrcodetype: qrCodeType
            }, {
                headers: {
                    Authorization: token,
                },
            })
            return res.data
        } catch (error) {
            console.error('QR İşlem hatası:', error)
            if (error.response && error.response.data && error.response.data.message) {
                return { success: false, message: error.response.data.message }
            }
            return { success: false, message: 'QR işlemi sırasında bir hata oluştu.' }
        }
    },

    // Salon doluluk kontrolü (Client-side helper)
    // seats: O seansın koltuk objesi { 1: {status: 'occupied'}, ... }
    isHallFull: (seats, hallId) => {
        if (!seats) return false

        const hallSeats = hallId === 1
            ? Array.from({ length: 40 }, (_, i) => i + 1)
            : Array.from({ length: 30 }, (_, i) => i + 41)

        return hallSeats.every(id => seats[id]?.status === 'occupied')
    }
}

export default LibraryService
